export * from 'employees/selectors/employees_selectors';



// WEBPACK FOOTER //
// src/modules/secured/modules/employees/selectors/index.js